module.exports = __webpack_public_path__ + "static/media/Products1.0bc1dbae.jpg";